/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.roles").
controller("DxRolesController", function RolesController(
	$rootScope,

	UIStateManager,
	Role,
	Invite,
	RoleTypeEnum,
	validationService,
	DxUser,
	DX_URLS,

	dxDialog,
	dxLocalize,

	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.Urls = DX_URLS;

	self.reqs = {
		node: true,
		statistics: false,
		roles: false,
		invites: false,
	};

	self.roleTypes = [2, 4, 16];
	self.state = new UIStateManager("overview");
	self.invite = new Invite();
	self.selectedRole = new Role();
	self.selectedRoleUsers = [];
	self.role = new Role();
	self.role.roleType = RoleTypeEnum.TEACHER;
	self.inviteSubmissionPending = false;
	self.batchErrors = [];

	loadUsersAndRoles();

	self.state.on("invite", function onInvite() {
		self.invite.roleId = defaultInviteRoleId();
	});

	self.state.on("viewrole", function onViewRole(data) {
		self.selectedRole = data.role;
		populateSelectedRoleUsers(data.role.userIds);
	});

	self.addRole = function addRole() {
		var hadRoles = self.node.roles.length > 0;
		return self.node.addRole(self.role).then(function success(role) {
			$rootScope.$broadcast("notification:success", dxLocalize.get("TheRoleXHasBeenCreated", role.title));
			self.role = new Role();
			self.role.roleType = RoleTypeEnum.TEACHER;
			self.state.set("overview");

			if ((self.invite.roleId == null) || !hadRoles) { // eslint-disable-line eqeqeq, no-eq-null
				self.invite.roleId = role.id;
			}
		});
	};

	self.confirmRemoveRole = function confirmRemoveRole(role) {
		if (role.externallyManaged && role.userIds.length) {
			return;
		}

		dxDialog.confirm({
			title: dxLocalize.get("DoYouWantToRemoveTheRole"),
			body: dxLocalize.get("DoYouWantToRemoveTheRoleX", role.title),
			acceptText: dxLocalize.get("Yes"),
			acceptCallback: function acceptCallback() {
				return removeRole(role);
			},
			rejectText: dxLocalize.get("No"),
		});
	};

	self.inviteUser = function inviteUser() {
		if (!self.batchErrors.length) {
			var emails = self.invite.emails.map(function map(email) {
				return typeof email[0] === "string" && email[0].trim();
			});

			self.inviteSubmissionPending = true;

			self.node.inviteUser({
				emails: emails,
				roleId: self.invite.roleId,
			}).then(function success(response) {
				var successMessage;

				if (response.length === 1) {
					successMessage = dxLocalize.get("TheInviteToXHasBeenSent", response[0].email);
				} else {
					successMessage = dxLocalize.get("TheInvitesToXPeopleBeenSent", response.length);
				}

				$rootScope.$broadcast("notification:success", successMessage);
				self.inviteSubmissionPending = false;

				clearInviteUser();

				self.state.set("overview");
				self.invite = new Invite({
					roleId: self.node.roles[0] ? self.node.roles[0].id : 0,
				});
			}, function errorCallback(response) {
				var error = (response.data.msgs != null ? response.data.msgs[0] : null) || response.data; // eslint-disable-line eqeqeq, no-eq-null, no-negated-condition
				self.inviteSubmissionPending = false;

				var i18nKey = emails.length === 1 ? "FailedToSendInvite" : "FailedToSendInvites";

				return $rootScope.$broadcast("notification:error", dxLocalize.get(i18nKey, error));
			});
		}
	};

	self.cancelInviteUser = function cancelInviteUser() {
		clearInviteUser();
		self.state.set("overview");
	};

	self.confirmRevokeUserRole = function confirmRevokeUserRole(role, user) {
		var extraInfo = "";
		if (role.externallyManaged) {
			extraInfo = " " + dxLocalize.get("RoleIsExternallyManaged");
		}

		dxDialog.confirm({
			title: dxLocalize.get("DoYouWantToRevokeTheRole"),
			body: dxLocalize.get("DoYouWantToRevokeTheRoleForX", user.name()) + extraInfo,
			acceptText: dxLocalize.get("Yes"),
			acceptCallback: function acceptCallback() {
				return revokeUserRole(role, user);
			},
			rejectText: dxLocalize.get("No"),
		});
	};

	self.resendInvite = function resendInvite(invite) {
		var promise = invite.resend();
		return promise.then(function success(response) {
			if (response.faults == null) { // eslint-disable-line eqeqeq, no-eq-null
				$rootScope.$broadcast("notification:success", dxLocalize.get("ResentTheInviteToX", invite.email));
			} else {
				$rootScope.$broadcast("notification:error", dxLocalize.get("CouldNotResendTheInviteToX", invite.email));
			}
		});
	};

	self.confirmRemoveInvite = function confirmRemoveInvite(invite) {
		dxDialog.confirm({
			title: dxLocalize.get("DoYouWantToRemoveTheInvite"),
			body: dxLocalize.get("DoYouWantToRemoveTheInviteToX", invite.email),
			acceptText: dxLocalize.get("Yes"),
			acceptCallback: function acceptCallback() {
				return removeInvite(invite);
			},
			rejectText: dxLocalize.get("No"),
		});
	};

	// Helpers
	self.getRoleTitleFromRoleId = function getRoleTitleFromRoleId(id) {
		var s = "";
		for (var j = 0; j < self.node.roles.length; j++) {
			var r = self.node.roles[j];

			if (r.id === id) {
				s = r.title;
				break;
			}
		}

		return s;
	};

	self.isPendingFilter = function isPendingFilter(invite) {
		return !invite.isClaimed;
	};

	self.getPendingInvites = function getPendingInvites() {
		var invites = [];
		for (var j = 0; j < self.node.invites.length; j++) {
			var i = self.node.invites[j];
			if (self.isPendingFilter(i)) {
				invites.push(i);
			}
		}

		return invites;
	};

	self.beforeParseBatchEntry = function beforeParseBatchEntry(data) {
		self.batchErrors = [];
		return data;
	};

	self.onValidateBatchEntry = function onValidateBatchEntry(rowArray, rowData) {
		var isValid = validationService.isEmailValid(rowArray[0].trim(), true);
		if (!isValid) {
			self.batchErrors.push(dxLocalize.get("PasteFrom.InvalidEmail", rowData.index + 1, rowData.source));
		}

		return isValid;
	};

	self.onErrorBatchEntry = function onErrorBatchEntry(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			var localizeKey = "PasteFrom.InvalidColumnCount." + (rowData.expectedLength > 1 ? "Plural" : "Singular") + "Expected";
			self.batchErrors.push(
				dxLocalize.get(
					localizeKey,
					rowData.index + 1,
					rowData.expectedLength,
					rowData.actualLength,
					rowData.source
				)
			);
		}
	};

	self.rolesManagedByDigiExamExist = function rolesManagedByDigiExamExist() {
		return defaultInviteRoleId() !== 0;
	};

	self.filterInvigilators = function filterInvigilators(role) {
		return role.roleType !== RoleTypeEnum.INVIGILATOR;
	};

	function loadUsersAndRoles() {
		self.node.loadRoles().then(function onLoadRoles(response) {
			var users = [];

			for (var i = 0; i < response.users.length; i++) {
				users.push(new DxUser(response.users[i]));
			}

			self.node.users = users;
			self.reqs.roles = true;
		});

		self.node.loadInvites().then(function onInvitesLoad() {
			self.reqs.invites = true;
		});
	}

	function populateSelectedRoleUsers(userIds) {
		self.selectedRoleUsers = [];
		for (var j = 0; j < userIds.length; j++) {
			var userId = userIds[j];
			var user = getUserById(userId);

			if (user) {
				self.selectedRoleUsers.push(user);
			}
		}
	}

	function removeRole(role) {
		dxDialog.closeMostRecent();
		return self.node.removeRole(role).then(function success() {
			return $rootScope.$broadcast("notification:success", dxLocalize.get("TheRoleXHasBeenDeleted", role.title));
		});
	}

	function clearInviteUser() {
		self.invite.emails = [];
		// Workaround because we don't have access to $element.
		angular.element("#invite-user-emails").val("");
	}

	function revokeUserRole(role, user) {
		dxDialog.closeMostRecent();
		var promise = role.revoke(user.id);
		promise.then(function success(response) {
			if (response.faults == null) { // eslint-disable-line eqeqeq, no-eq-null
				if (self.state.is("viewrole") && role.userIds.length === 0) {
					self.state.set("overview");
				} else {
					populateSelectedRoleUsers(role.userIds);
				}
				$rootScope.$broadcast("notification:success", dxLocalize.get("RevokedRoleXFromX", role.title, user.name()));
			} else {
				$rootScope.$broadcast("notification:error", dxLocalize.get("CouldNotRevokeRoleXFromX", role.title, user.name()));
			}
		});
	}

	function removeInvite(invite) {
		dxDialog.closeMostRecent();
		var promise = self.node.removeInvite(invite);
		return promise.then(function success(response) {
			if (response.faults == null) { // eslint-disable-line eqeqeq, no-eq-null
				$rootScope.$broadcast("notification:success", dxLocalize.get("RemovedTheInviteToX", invite.email));
			} else {
				$rootScope.$broadcast("notification:error", dxLocalize.get("CouldNotRemoveTheInviteToX", invite.email));
			}
		});
	}

	function getUserById(userId) { // eslint-disable-line consistent-return
		for (var j = 0; j < self.node.users.length; j++) {
			var u = self.node.users[j];
			if (u.id === userId) {
				return u;
			}
		}
	}

	function defaultInviteRoleId() {
		for (var j = 0; j < self.node.roles.length; j++) {
			var role = self.node.roles[j];
			if (role && !role.externallyManaged) {
				return role.id;
			}
		}

		return 0;
	}
});
